module.exports = {
  RECEIVE_B2C: 'RECEIVE_B2C'
};
